import { Text, View, Image, Document, Page, StyleSheet } from '@react-pdf/renderer';
import { peicarLogo, peicarLogo2 } from '../../../../Assets/Images';
import { BsBorderBottom } from 'react-icons/bs';

export default function TopBlock({ detalle, resumen, allDetalleState }) {
    const pageStyle = {
        display: 'flex',
        border: '8px solid #32b8df',
        fontSize: '8px',
        padding: '8px',
        color: '#2e373b'
    };

    const pageCounter = {
        position: 'absolute',
        bottom: '4px',
        right: '4px',
        fontSize: '10px'
    };


    let pages = 1;
    if (detalle.length >= 37) pages = 2;

  /*   let bodyData = [];
    const sliceIndex = detalle.length === 37 ? 31 : 44;

    if (pages > 1) {
        bodyData.push(detalle.slice(0, sliceIndex));
        bodyData.push([detalle[0], ...detalle.slice(sliceIndex)]);
    } else {
        bodyData.push(detalle);
    } */

    const mainBlock = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontFamily: 'Helvetica-Bold',
        marginBottom: '8px'
    };

    const justifyBetween = {
        justifyContent: 'space-between'
    };

    const leftLogo = {
        width: '100px',
        marginLeft: '20px',
        marginTop: '10px',
    };

    const leftCol = {
        display: 'flex',
        width: '100%',
        // padding: '20px 0',
        // backgroundColor: '#f2f2f2',
        // borderRadius: '10px',
    };
    const leftCol1 = {
        display: 'flex',
        width: '100%',
        // padding: '0 0 20px 0',
        backgroundColor: '#f2f2f2',
        borderRadius: '10px',
        borderBottom: '1px solid #0c225e',
    };
    const leftTableRow = {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '5px',
    };

    const leftTableRowPlus = {
        width: '280px',
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '5px',
    };

    const cell = {
        flexBasis: '0',
        flexGrow: '1',
    };

    const rightCol = {
        display: 'flex',
        justifyContent: 'space-between',
        width: '280px',
        marginTop: '60px',
    };

    const rightColPlus = {
        display: 'flex',
        justifyContent: 'space-between',
        width: '280px',
        marginTop: '20px',
        fontFamily: 'Helvetica-Bold',
        fontSize: '8px',
    };

    const rightImgContainer = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const rightInfo = {
        display: 'flex',
        width: '265px',
    };

    const rightInfoPlus = {
        display: 'flex',
        width: '265px',
        flexDirection: 'row',
    };

    const rightLogo = {
        width: '180px'
    };

    const clientNameRow = {
        with: "100%",
        marginTop: '4px',
        // marginBottom: '6px',
        display: 'flex',
        flexDirection: 'row',
        // alignItems: 'center',
        // padding: '10px',
        gap: '0px'
    };

    const carDesc = {
        fontSize: '10px',
        // marginBottom: '6px',
        fontFamily: 'Helvetica-Bold'
    };

    const carDescPlus = {
        fontSize: '12px',
        fontFamily: 'Helvetica-Bold'
    };

    const rightTableRow = {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '3px',
    };

    const rightSubTableRow = {
        width: '60%',
        display: 'flex',
        flexDirection: 'row',
        fontSize: '7px',
        marginLeft: '16px'
    };

    const leftCell = {
        width: '55%',
    };

    const symbolCell = {
        width: '10%'
    };

    const symbolCellPlus = {
        width: '10%',
        marginLeft: '65px'
    };

    let meses = detalle.length - 1;
    let table = Object.entries(resumen);
    // console
    let leftTable, rightTable;

    if (resumen['pdf']) {
        leftTable = table.slice(2, table.length - 7);
        rightTable = table.slice(table.length - 7);
    } else {
        leftTable = table.slice(8, table.length - 7);
        rightTable = table.slice(13, table.length);
    }

    const firstPart = {
        with: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        height: "80px",
        margin: "auto",
        marginLeft: "30px",
        marginTop: "10px",
    }

    const titleStyle = {
        flexBasis: '10%', // You can adjust this value to control the space for the title
        fontWeight: 'bold',
        color: '#0c225e'
    }

    const valueStyle = {
        flex: "1",
        flexBasis: '20%',
    }
    const titleStyleLarge = {
        flexBasis: '15%', // You can adjust this value to control the  space for the title
        fontWeight: 'bold',
        color: '#0c225e'
    }

    const valueStyleLarge = {
        flex: "1",
        flexBasis: '25%',
    }

    const cellGeneric = (title, value, isLarge) => {
        return <View style={clientNameRow}>
            <Text style={isLarge ? titleStyleLarge : titleStyle} >{title}:</Text>
            <Text style={isLarge ? valueStyleLarge : valueStyle} >{value}</Text>
        </View>
    }

    const conteinerCell = {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start"
    }

    const tablee = {
        display: "table",
        width: "100%",
        // borderStyle: "solid",
        // borderWidth: 1,
        // borderColor: '#bfbfbf',
        margin: "auto",
        padding: "10px 0",

    }
    const tableRow = {
        margin: "auto",
        flexDirection: "row",
        margin: "3px 10px",
        display: "flex",
        justifyContent: "space-between",

    }
    // const tableRow = {
    //     margin: "auto",
    //     flexDirection: "row",
    //     margin: "3px 10px",
    // }
    const tableCol = {
        // width: "20%",
        // borderStyle: "solid",
        // borderWidth: 1,
        // borderColor: '#bfbfbf'
    }
    const tableColPlazo = {
        width: "17%",
        gap: "7px",
        margin: "0 .7px",
        borderRadius: "5px",
        // borderStyle: "solid",
        // borderWidth: 1,
        // borderColor: '#bfbfbf'
    }

    const tableCell = {
        // margin: "auto",
        marginTop: 1,
        fontSize: '7px',
        textAlign: 'center',

    }

    const tableCellHeader = {
        // margin: "auto",
        marginTop: 0,
        fontSize: '8px',
        textAlign: 'right',

    }


    const reportTitle = {
        color: '#0c225e',
        letterSpacing: 4,
        fontSize: "15px",
        textAlign: 'center',
        textTransform: 'uppercase',
        padding: ' 20px 0 0  0',
        // borderBottom: '1px solid #33b8df',

    }

    // resumen['pdfPlazo'].sort((a, b) => a.plazo - b.plazo);





    return (
        // resumen['pdf'] ? (
        <View >
            <View style={mainBlock} fixed>
                {/* LEFT COLUMN */}
                <View style={leftCol}>
                    <View style={leftCol1}>
                        {/* Left Logo PEICAR */}
                        <Image src={peicarLogo} style={leftLogo} />

                        {/* <Text style={{ marginTop: '8px', marginBottom: '4px' }}>
                            Cotización Arrendamiento Financiero - PLAZO {meses} MESES
                        </Text>

                        {/* ESTIMADO SR(A): */}
                        <Document style={firstPart} >
                            <Document style={conteinerCell}>

                                {cellGeneric(table[0][0], table[0][1])}

                                {/* {cellGeneric("Distribuidora", "")}

                                {cellGeneric("Vendedor", "")} */}

                                {cellGeneric("ID seguro", resumen["iDSeguro"])}

                                {cellGeneric("Aseguradora", resumen["Aseguradora"])}

                                {cellGeneric("ID cotización", resumen["iDCotización"])}

                            </Document>
                            {/* {cellGeneric("version", resumen['version'])} */}
                            <Document style={{ display: "flex", width: "100%" }}>
                                {cellGeneric("Version", resumen['version'])}

                                <Document style={{ width: "100%",display:"flex", gap:"1em" , flexDirection:"row", marginTop:"5px"}}>
                                    <View  >

                                        {cellGeneric("Marca", resumen["Marca"])}

                                        {cellGeneric("Modelo", resumen["Modelo"])}

                                        {/* {cellGeneric("version", resumen['version'])} */}
                                        {/* {cellGeneric("Version", "")} */}
                                        {cellGeneric("Tipo Motor", resumen["tipoMotor"])}
                                        {cellGeneric("Año", resumen["Año"])}
                                        {cellGeneric("Tipo auto", resumen["tipoAuto"])}


                                    </View>

                                    <View >

                                        {cellGeneric("Precio del vehiculo $ (c/IVA)", resumen["Precio del Vehículo"], true)}

                                        {cellGeneric("Accesorios $ (c/IVA)", resumen["Accesorios"], true)}

                                        {cellGeneric("Plazo", resumen['Plazo'], true)}
                                        {/* {cellGeneric("Gasto Otorgamiento", 0, true)} */}
                                        {cellGeneric("Valor Residual", resumen["valorResidual"], true)}
                                        {cellGeneric("Estado Placa", resumen["placa"], true)}

                                    </View>

                                </Document>
                            </Document>

                        </Document>
                        <Text style={reportTitle}> {resumen["isPure"] ? "Arrendamiento Puro" : "Arrendamiento Financiero"}</Text>


                    </View>


                    <View style={tablee}>

                        {/* Table Header */}
                        <View style={tableRow}>
                            <View style={[tableCol, { width: "25%" }]}>
                                {/* <Text style={{
                                    marginTop: "5",
                                    fontSize: '10px',
                                    textAlign: 'right',
                                    marginRight: "10px"
                                }}>Mensualidad</Text> */}
                            </View>
                            {allDetalleState.map((item, index) => {
                                return (
                                    <View style={[tableColPlazo, { backgroundColor: item.selected ? "#00ba6e" : "#30b4da", color: "white", width: "19%" }]} key={index}>
                                        <Text style={[tableCell, { paddingTop: "3px", paddingBottom: "3px" }]}>{item.plazo}</Text>
                                    </View>)
                            })}
                        </View>

                        {allDetalleState.some(item => item.residual_capped) && (
                            <View style={tableRow}>
                                <View style={[tableCol, { width: "25%" }]} />
                                {allDetalleState.map((item, index) => (
                                    <View style={[tableCol, { width: "19%" }]} key={index}>
                                        {item.residual_capped ? (
                                            <Text style={{ fontSize: "8px", paddingTop: "3px", paddingBottom: "3px", textAlign: "center", color: "#7c2d12", fontStyle: "italic" }}>
                                                Residual ajustado: {item.residual_percentage}%
                                            </Text>
                                        ) : null}
                                    </View>
                                ))}
                            </View>
                        )}

                        {/* Table Rows */}


                        <Text style={[reportTitle, { padding: "5px 0 5px 30px", marginLeft: "147px", fontSize: "10px", }]}>MENSUALIDAD</Text>

                        {Object.keys(allDetalleState[0].section3).map((key, index) => (
                            <View style={tableRow} key={index}>
                                <View style={tableRow} key={index}>
                                    <View style={[[tableCol, { width: "24%" }]]}>
                                        <Text style={[tableCellHeader, { paddingRight: "10px", marginLeft: "10px", gap: "10px" }]}>{key}</Text>
                                    </View>
                                    {allDetalleState.map((item, rowIndex) => {
                                        return (
                                            <View style={[tableCol, { width: "30%", paddingLeft: "40px" }]} key={rowIndex}>
                                                <Text style={tableCell}>${item.section3[key][1]}</Text>
                                                {key === "IVA" && <hr style={{ width: '100%', border: '0.5px solid black', margin: '2px 0 0 0' }} />}

                                            </View>

                                        )
                                    }
                                    )}
                                </View>
                            </View>

                        ))}
                        <Text style={[reportTitle, { padding: "5px 0 5px 30px", marginLeft: "148px", fontSize: "10px" }]}>Desembolso Inicial</Text>

                        {/* <View style={{ paddingTop: "10px" }}>
                            {Object.keys(allDetalleState[0].section2).map((key, index) => (
                                <View style={[tableRow, {justifyContent:"start"}]} key={index}>
                                    <View style={[tableCol, { width: "25%" }]}>
                                        <Text style={[tableCellHeader, { paddingRight: "10px" }]}>{key}</Text>
                                    </View>
                                    {resumen["isPure"] ? (
                                        allDetalleState.map((item, rowIndex) => (
                                            <View style={tableCol} key={rowIndex}>
                                                <Text style={tableCell}>${item.section2[key][1]}</Text>
                                                {key === "IVA" && <hr style={{ width: '100%', border: '0.5px solid black', margin: '2px 0 0 0' }} />}
                                            </View>
                                        ))
                                    ) : (
                                        allDetalleState.map((item, rowIndex) => (
                                            item.plazo === 24 ? (
                                                <View style={[tableCol, { textAlign: "center", display: "flex", position: "relative", left: "208px" }]} key={rowIndex}>
                                                    <Text style={[tableCell, { alignContent: "center", textAlign: "center" }]}>${item.section2[key][1]}</Text>
                                                    {key === "IVA" && <hr style={{ width: '70vw', border: '0.5px solid black', margin: '2px 0 0 0', right: "200px" }} />}
                                                </View>
                                            ) : null
                                        ))
                                    )}
                                </View>
                            ))}
                        </View> */}

                        <View style={{ paddingTop: "10px" }}>
                            {Object.keys(allDetalleState[0].section2).map((key, index) => (
                                // <View style={[tableRow, {width:"100%", justifyContent: resumen["isPure"] ? "start":"space-evenly"}]} key={index}>
                                <View style={[tableRow, !resumen["isPure"] ? { justifyContent: "start" } : {}]} key={index}>

                                    <View style={[tableCol, { width: "25%" }]}>
                                        <Text style={[tableCellHeader, { paddingRight: "10px" }]}>{key}</Text>
                                    </View>
                                    {resumen["isPure"] ? (
                                        allDetalleState.map((item, rowIndex) => (
                                            <View style={[tableCol,{ width: "25%", paddingLeft: "40px" }]} key={rowIndex}>
                                                <Text style={[tableCell, {textAlign:"center"}]}>${item.section2[key][1]}</Text>
                                                {key === "IVA" && <hr style={{ width: '100%', border: '0.5px solid black', margin: '2px 0 0 0' }} />}
                                                {key === "Depósito en Garantía (incl IVA)" && <hr style={{ width: '100%', border: '0.5px solid black', margin: '2px 0 0 0' }} />}

                                            </View>
                                        ))
                                    ) : (
                                        allDetalleState.map((item, rowIndex, i) => (
                                            rowIndex === 0? (
                                                <View style={[tableCol, { textAlign: "center", display: "flex", position: "relative", left:  "210px"}]} key={rowIndex}>
                                                    <Text style={[tableCell, { alignContent: "center", textAlign: "center" }]}>${item.section2[key][1]}</Text>
                                                    {key === "IVA" && <hr style={{ width: '70vw', border: '0.5px solid black', margin: '2px 0 0 0', right: "200px"  }} />}
                                                {key === "Depósito en Garantía (incl IVA)" && <hr style={{ width: '100%', border: '0.5px solid black', margin: '2px 0 0 0' }} />}

                                                </View>
                                            ) : null
                                        ))
                                    )}
                                </View>
                            ))}
                        </View>

                        {resumen['residual'] && (
                            <Text style={[reportTitle, { padding: "10px 0 10px 30px", fontSize: "10px", letterSpacing: 1, }]}>Valor Residual (incl IVA) {resumen['residual']}% {'='} {resumen['residualValue']} </Text>
                        )}
                        {allDetalleState.some(item => item.residual_capped) && (
                            <Text style={{ padding: "0 0 6px 30px", fontSize: "7px", color: "#7c2d12", fontStyle: "italic" }}>
                                {allDetalleState
                                    .filter(item => item.residual_capped)
                                    .map(item => `Valor residual modificado para ${item.plazo}m: ${item.residual_percentage}%`)
                                    .join("  ·  ")}
                            </Text>
                        )}


                    </View>


                </View>


            </View>


        </View >

    )
}